export const blockIconsMapsPark = (
	<span className='material-symbols-outlined'>park</span>
);
